var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedMountingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FFA700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.552 16.391a8.72 8.72 0 00-1.752-3.305 5.59 5.59 0 00.076-.685c-.133.095-.257.219-.38.342-.068-.066-.125-.133-.191-.2l-.39-.39c.037-.22.056-.438.066-.648a3.97 3.97 0 00-.381.334l-.59-.59c.037-.22.056-.439.066-.648-.124.095-.257.21-.38.333l-.591-.59c.038-.22.057-.439.066-.648-.124.095-.257.21-.38.333l-.591-.59c.038-.22.057-.438.067-.648-.124.095-.258.21-.381.333l-.41-.41-2.752 2.782 1.314 1.314a5.155 5.155 0 00-.067.648c.124-.095.257-.21.381-.334l.59.59c-.037.22-.056.439-.066.649.124-.096.257-.21.381-.334l.59.59c-.038.22-.057.439-.066.648.124-.095.257-.21.38-.333l.391.39c.067.067.133.134.2.19-.038.22-.067.439-.067.649.134-.105.267-.23.4-.353.191.162.391.314.6.467a4.59 4.59 0 00-.095.79c.181-.143.362-.314.534-.495.704.438 1.476.78 2.285 1l1.59.429-.447-1.61zM10.8 6L8.59 8.2l.315.314-.39.39L8.2 8.59 6 10.8l1.057 1.676 5.42-5.419L10.8 6z",
    fill: "#fff"
  })));
}

export default SvgLedMountingIcon;